import { Company } from '../user/clients/clients-list';
import { Dispatch } from '@reduxjs/toolkit';
import apiClient from './auth.interceptor';
import { errorToast } from './toast.service';
import { setCurrentUser } from './redux/userSlicer';
import { IUser } from '../user/user.interface';
import { IFirm } from './redux/firmSlicer';
import { UserRoles } from '../admin/users/useFetchUsers.hook';

export enum LocalStorageKey {
  ACCESS_TOKEN = 'access_token',
  REFRESH_TOKEN = 'refresh_token'
}

export interface UserModel {
  email: string;
  name: string;
  role: string;
  firmNames: string[];
  companies: Company[];
}

interface LoginResponse {
  access_token: string;
  refresh_token: string;
  user: UserModel;
}

export const doLogin = (response: LoginResponse) => {
  try {
    const { access_token, refresh_token } = response;
    if (access_token) {
      localStorage.setItem(LocalStorageKey.ACCESS_TOKEN, access_token);
    }
    if (refresh_token) {
      localStorage.setItem(LocalStorageKey.REFRESH_TOKEN, refresh_token);
    }
  } catch (e) {
    console.log(e);
  }
};
export const userRefresh = async (dispatch: Dispatch): Promise<IUser> => {
  try {
    const response = await apiClient.get('/v1/user');
    const user = response.data;
    if (user) {
      dispatch(setCurrentUser(user));
    }
    return user;
  } catch (e) {
    errorToast('An error occurred while fetching clients');
    throw e;
  }
};
export const firmRefresh = async (): Promise<IFirm[]> => {
  try {
    const response = await apiClient.get('/v1/firm');
    return response.data;
  } catch (e) {
    errorToast('An error occurred while fetching clients');
    throw e;
  }
};

export const getUserRole = (user: IUser | null, currentFirm: IFirm | null): UserRoles => {
  if (!user || !currentFirm) {
    return UserRoles.simple_user;
  }
  if (currentFirm?.ownerId === user?._id) {
    return UserRoles.super_admin;
  }
  if (user?._id && currentFirm?.users?.includes(user?._id)) {
    return UserRoles.admin;
  }
  return UserRoles.simple_user;
};
